/** Returns a function, that, as long as it continues to be invoked, will not
 * be triggered.
 *
 * Example usage:
 * function saveInput(){
 *  `console.log('Saving data');
 * }
 * `const processChange = debounce(() => saveInput());
 */
// eslint-disable-next-line import/prefer-default-export
export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

/**
 * selectors to hide elements.
 * place these on the page-content evo widget where possible
 */
(() => {
  // add breadcrumb-hide class anywhere on page to hide row with breadcrumbs
  document.querySelectorAll('.js-breadcrumb-hide').forEach(() => {
    document.querySelectorAll('#breadcrumb').forEach((item) => {
      item.style.display = 'none';
    });
  });

  // margins for: zonetop, zonebottom, catalog-grid.
  if (document.querySelector('.js-zonetop-nomargin')) {
    document.querySelector('.zonetop').style.marginBottom = '0';
  }
  if (document.querySelector('.js-zonebottom-nomargin')) {
    document.querySelector('.zonebottom').style.marginTop = '0';
  }
  if (document.querySelector('.js-catalog-nomargin')) {
    document.querySelector('.catalog-grid').style.marginTop = '0';
  }

  // no margins for all: zonetop, zonebottom, catalog-grid.
  if (document.querySelector('.js-no-margins')) {
    if (document.querySelector('.zonetop')) {
      document.querySelector('.zonetop').style.marginBottom = '0';
    }

    if (document.querySelector('.zonebottom')) {
      document.querySelector('.zonebottom').style.marginTop = '0';
    }

    if (document.querySelector('.catalog-grid')) {
      document.querySelector('.catalog-grid').style.marginTop = '0';
    }
  }

  // no margins for all, and hide breadcrumb
  if (document.querySelector('.js-no-margins-breadcrumb')) {
    if (document.querySelector('.zonetop')) {
      document.querySelector('.zonetop').style.marginBottom = '0';
    }

    if (document.querySelector('.zonebottom')) {
      document.querySelector('.zonebottom').style.marginTop = '0';
    }

    if (document.querySelector('.catalog-grid')) {
      document.querySelector('.catalog-grid').style.marginTop = '0';
    }

    if (document.querySelector('.page-content')) {
      document.querySelector('.page-content').style.marginTop = '0';
      document.querySelector('.page-content').style.marginBottom = '0';
    }

    document.querySelectorAll('.row-breadcrumb').forEach((item) => {
      item.style.display = 'none';
    });
  }
})();

/**
 * Additional JS Selectors
 */
(() => {
  // add ieOnly class to body if the browser used is IE
  if (navigator.userAgent.match(/msie|trident/i)) {
    document.body.classList.add('ieOnly');
  }
})();
